import CSS from './Button.module.css';
import type { MouseEvent } from 'react';
import type { SoundName } from 'cuelume';
import { useNavigateQuery } from '@/hooks';
type ClickEvent = MouseEvent<HTMLButtonElement>;
import { pushEvent, useClassNames } from '@CS/hooks';
import type { ReactNode, ButtonHTMLAttributes } from 'react';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  sound?: [SoundName, SoundName] | SoundName | null;
  onClick?: (event: ClickEvent) => unknown;
  type?: 'button' | 'submit' | 'reset';
  children?: ReactNode | ReactNode[];

  className?: string;
  gtmConfig?: object;
  disabled?: boolean;

  linkClick?: true;
  width?: string;
  link?: string;

  text?: string;
  blank?: true;
  id?: string;
};

export const Button = ({
  sound = ['press', 'release'],
  text = '',
  className,
  gtmConfig,
  linkClick,
  disabled,
  children,
  onClick,
  width,
  blank,
  link,
  id,
  ...props
}: ButtonProps) => {
  const navigate = useNavigateQuery();
  const classNames = useClassNames([CSS.standard, className]);

  const sounds =
    (!sound && {}) ||
    Object.fromEntries(
      (Array.isArray(sound) && sound.map(s => [`data-cuelume-${s}`, ''])) || [
        ['data-cuelume-press', sound as SoundName]
      ]
    );

  const onButtonClick = (event: ClickEvent) => {
    gtmConfig && pushEvent(gtmConfig);

    if (linkClick || !link) onClick?.(event);
    else if (blank) open(link, '_blank');
    else void navigate(link);
  };

  return (
    <button
      style={{ width: width || 'auto' }}
      onClick={onButtonClick}
      className={classNames}
      disabled={disabled}
      role="button"
      {...sounds}
      {...props}
      id={id}
    >
      {text || children}
    </button>
  );
};
